'use client';

import type { MysteryRoomLocalRuntime } from '../core/localRuntime';
import type { MrMatchSnapshot } from '../net/mysteryRoomApi';

type PhaserModule = typeof import('phaser');

type RuntimeAdapter = {
  getMode: () => 'server' | 'local';
  getSnapshot: () => MrMatchSnapshot | null;
  getSelfPlayerId: () => string | null;
  getLocalRuntime?: () => MysteryRoomLocalRuntime | null;
};

export function createUIScene(Phaser: PhaserModule, adapter: RuntimeAdapter) {
  return class UIScene extends Phaser.Scene {
    private statusText: any = null;

    constructor() {
      super({ key: 'UIScene' });
    }

    create() {
      this.statusText = this.add.text(18, 18, 'Connecting…', {
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
        fontSize: '14px',
        color: '#f8fafc',
        backgroundColor: 'rgba(2, 6, 23, 0.82)',
        padding: { x: 12, y: 8 },
      });
      this.statusText.setScrollFactor(0);
      this.statusText.setDepth(2000);
    }

    update() {
      if (!this.statusText) {
        return;
      }

      if (adapter.getMode() === 'local') {
        this.statusText.setVisible(true);
        const runtime = adapter.getLocalRuntime?.();
        const trespass = runtime?.security.trespass;
        const securityLine = trespass
          ? trespass.escalatedAtMs === null
            ? `Security: warning ${trespass.zoneTitle}`
            : `Security: alarm call ${trespass.zoneTitle}`
          : 'Security: clear';
        this.statusText.setText([
          'Local core slice',
          `Zone: ${runtime?.hero.zoneId ?? 'n/a'}`,
          securityLine,
          `Alarm: ${runtime?.worldAlarm.state ?? 'clear'}`,
          `Hero: ${runtime?.hero.animationState ?? 'idle'} / ${runtime?.hero.movementMode ?? 'idle'}`,
          `Doors open: ${runtime?.doors.filter((door) => door.state === 'open').length ?? 0}`,
        ]);
        return;
      }

      this.statusText.setVisible(false);
    }
  };
}
